import React from 'react';
import Table from '@material-ui/core/Table';
import { useSelector } from 'react-redux';
import TableBody from '@material-ui/core/TableBody';
import DownloadItemCell from './DownloadItemCell';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

const ListTableView = () => {
  const { shortCriticsList } = useSelector(({ critics }) => critics);

  return (
    <React.Fragment>
      <Box className="Cmt-table-responsive">
        <Table>
          <TableBody>
            {shortCriticsList.map(item => (
              <DownloadItemCell key={item.id} critic={item} />
            ))}
          </TableBody>
        </Table>
      </Box>
    </React.Fragment>
  );
};

export default ListTableView;

ListTableView.prototype = {
  checkedContacts: PropTypes.array,
  handleCellCheckBox: PropTypes.func,
  handleHeaderCheckBox: PropTypes.func,
  updateCheckedContacts: PropTypes.func,
  onShowContactDetail: PropTypes.func,
};

ListTableView.defaultProps = {
  checkedContacts: [],
};
